import {memo, useState} from "react";
import Close from "@/icons/close.svg?react";

/**
 * Message component for displaying messages to the user.
 */
const Message = ({
  type,
  children,
  className,
  closeable,
  onCloseClick,
}: {
  type: "xsmall" | "small" | "medium" | "large";
  children: React.ReactNode;
  className?: string;
  closeable?: boolean;
  onCloseClick?: () => void;
}) => {
  const [isClosed, setIsClosed] = useState(false);

  if (isClosed) {
    return null;
  }

  return (
    <div
      className={[
        "relative",
        type === "xsmall"
          ? "rounded-md bg-[orange] p-3 text-center text-sm text-[black] sm:mx-auto sm:w-auto sm:max-w-lg"
          : "",
        type === "small"
          ? "rounded-md bg-[orange] px-4 py-6 text-sm text-[black] sm:mx-auto sm:w-auto sm:max-w-lg sm:px-6"
          : "",
        type === "medium"
          ? "bg-surface-bright text-on-surface py-g-2 col-span-6 flex flex-col rounded-md px-6 sm:px-8"
          : "",
        type === "large"
          ? "py-g-2 xs:text-lg sm:text-md col-span-6 flex flex-col rounded-md bg-[orange] px-6 text-sm text-[black] sm:px-8"
          : "",
        className || "",
      ].join(" ")}
    >
      {children}
      {closeable && (
        <button
          type="button"
          aria-label="Zavřít zprávu"
          className="absolute top-3 right-3 -m-3 cursor-pointer appearance-none border-0 bg-transparent p-3"
          onClick={() => {
            setIsClosed(true);
            onCloseClick?.();
          }}
        >
          <Close className="size-i-2 fill-black" />
        </button>
      )}
    </div>
  );
};

export default memo(Message);
